<template>
  <v-sheet class="pa-2" border color="grey-lighten-5" elevation="0">
    <div v-for="option in options" :key="option.id">
      <div class="text-h6">
        Option {{ option.nom }} <span v-if="!type == 'refund'">| ID. {{ option.id }}</span>
      </div>
      <div class="d-flex sm-gap">
        <v-chip variant="elevated" color="white" elevation="0" border> Quantité : {{ option.quantite }} </v-chip>
        <v-chip variant="elevated" color="white" elevation="0" border> Prix : {{ option.prix }}€ </v-chip>
        <v-chip variant="elevated" color="white" elevation="0" border>
          <v-icon v-if="option.valide == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
          <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
          Payée
        </v-chip>
      </div>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: ["options"],
};
</script>

<style lang="scss" scoped>
</style>